import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="frame-scroll"
// Switching filters can shrink the list below the current scroll offset, which makes the
// browser clamp scrollY towards 0 and feels like an unrelated jump to the top of the page.
// Anchoring to the frame's own top on every re-render keeps that jump consistent and intentional.
export default class extends Controller {
    scrollToTop() {
        this.element.scrollIntoView({ block: "start" })
    }
}
